import axios, { AxiosResponse } from "axios";
import { getValidToken } from "../../../utils/authUtils";
import { ApiResponse } from "../types";

// Base API configuration
const API_BASE_URL = `${process.env.REACT_APP_API_HOST}project-module/`;

// Helper function to handle API responses
const handleApiResponse = <T>(response: AxiosResponse<ApiResponse<T>>): T => {
  if (response.data.isSuccess) {
    return response.data.data!;
  } else {
    throw new Error(response.data.error || "API request failed");
  }
};

// Helper function to get auth headers
const getAuthHeaders = async () => {
  const token = await getValidToken();
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

export const projectMasterDataApi = {
  getProjectMasterDataByType: async (
    masterDataType: string,
    projectId: string,
    allocationId?: string
  ) => {
    try {
      const url = allocationId
        ? `${API_BASE_URL}master-data/${projectId}/type/${masterDataType}/excluding/${allocationId}`
        : `${API_BASE_URL}master-data/${projectId}/type/${masterDataType}`;
      const response = await axios.get<ApiResponse<any[]>>(url,
        { headers: await getAuthHeaders() }
      );
      return handleApiResponse(response);
    } catch (error) {
      console.error("Error fetching project master data by type:", error);
      throw error;
    }
  },
  getRoutesWithSchedules: async (projectId: string) => {
    try {
      const response = await axios.get<ApiResponse<any[]>>(
        `${API_BASE_URL}master-data/routes-with-schedules/${projectId}`,
        { headers: await getAuthHeaders() }
      );
      return handleApiResponse(response);
    } catch (error) {
      console.error("Error fetching project master data by type:", error);
      throw error;
    }
  },
  getRouteAndSchedulesByRouteId: async (routeId: string) => {
    try {
      const response = await axios.get<ApiResponse<any[]>>(
        `${API_BASE_URL}master-data/route-and-schedules/${routeId}`,
        { headers: await getAuthHeaders() }
      );
      return handleApiResponse(response);
    } catch (error) {
      console.error("Error fetching project master data by type:", error);
      throw error;
    }
  },
};
